import React from 'react';
import { IconLoader2 } from '@tabler/icons-react';

/**
 * MLoader - A generic, centered loading spinner using Tabler's Loader2 icon.
 * Usage: <MLoader />
 */
interface MLoaderProps {
  size?: number;
  color?: string;
}

const MLoader: React.FC<MLoaderProps> = ({ size = 24, color = '#2A2A2A' }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        width: '100%',
      }}
      data-testid="m-loader-root"
    >
      <IconLoader2
        className="m-loader-spinner"
        size={size}
        style={{
          width: size,
          height: size,
          animation: 'm-loader-spin 1s linear infinite',
          color: color,
        }}
      />
      <style>{`
        @keyframes m-loader-spin {
          100% { transform: rotate(360deg); }
        }
        .m-loader-spinner {
          display: inline-block;
        }
      `}</style>
    </div>
  );
};

export default MLoader;
